'use strict';

var base = require('../product/base');
var quickView = require('../product/quickView');
var focusHelper = require('../components/focus');
var breakpoints = require('../components/breakpoints');
var slickSlider = require('../thirdParty/slickSlider');
var scrollAnimate = require('../components/scrollAnimate');
var promoProgressBar = require('../components/promoProgressBar');
var shippingHelpers = require('../checkout/shipping');
var utils = require('../utils');
require('jquery-zoom/jquery.zoom.js');
var _ = require('lodash');
var debounce = require('lodash/debounce');
let isUndoAjaxInProgress = false;
// eslint-disable-next-line no-undef
const removeUrlCooldownMap = new Set();

/**
 * Validate whole form. Requires `this` to be set to form object
 * @param {jQuery.event} form - Event to be canceled if form is invalid.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateForm(form) {
    var valid = true;
    if (form.checkValidity && !form.checkValidity()) {
        // safari
        valid = false;
        $(form).find('input, select').each(function () {
            if (!this.validity.valid) {
                $(this).trigger('invalid', this.validity);
            }
        });
        scrollAnimate($(form).find('.is-invalid:first'));
    }
    return valid;
}

/**
 * Validate a form element. Requires `this` to be set to form object
* @param {jQuery.event} input - form input.
 * @returns {boolean} - Flag to indicate if form is valid
 */
function validateFormElement(input) {
    var valid = true;
    var form = input.closest('form');
    if (($(input).data('must-match') && $('#' + $(input).data('must-match')).length)
        && $('#' + $(input).data('must-match')).val().length
        && $(input).val() !== $('#' + $(input).data('must-match')).val()) {
        valid = false;
        if ($(input).data('match-error')) {
            $(input).data('custom-error', ($(input).data('match-error')));
        } else {
            $(input).data('custom-error', 'Fields do not match');
        }
        $(input).trigger('invalid', input.validity);
        scrollAnimate($(form).find('.is-invalid:first'));
    }

    return valid;
}

/**
 * Centers all slick-arrow elements vertically
 * relative to the center of the product image.
 * @param {string|jQuery|Element} context - The context in which to center slick arrows.
 */
function centerSlickArrows(context) {
    let scope;

    if (typeof context === 'string') {
        scope = document.querySelector(context);
    } else if (context && context.jquery) {
        scope = context[0];
    } else if (context instanceof Element) {
        scope = context;
    } else {
        scope = document;
    }

    if (!scope) return;

    const images = scope.querySelectorAll('.product-image-content');
    if (!images.length) return;

    images.forEach(function (image) {
        const imageTop = image.offsetTop;
        const imageHeight = image.offsetHeight;
        const imageCenter = imageTop + (imageHeight / 2);

        const container = image.closest('.slick-initialized, .slick-slider');
        if (!container) return;
        const arrows = container.querySelectorAll('.slick-arrow');

        arrows.forEach(function (arrow) {
            const innerArrows = arrow.querySelectorAll('.svg-right-arrow, .svg-left-arrow');
            if (innerArrows.length) {
                innerArrows.forEach(function (inner) {
                    const arrowHeight = inner.offsetHeight || inner.scrollHeight || 40;
                    const centeredTop = imageCenter - (arrowHeight / 2);
                    // eslint-disable-next-line no-param-reassign
                    inner.style.top = centeredTop + 'px';
                });
            } else {
                // eslint-disable-next-line no-param-reassign
                arrow.style.top = imageCenter + 'px';
            }
        });
    });
}

/**
 * Initiate slick slider
 */
function setSlickSlider() {
    $('.primary-images').each(function () {
        if ($(this).hasClass('js_non-carousel')) {
            return true;
        }

        var $this = $(this);
        if ($this.hasClass('pdp-primary-images') && !$this.closest('.modal').length) {
            return true;
        }
        var selector = $('.carousel-inner', this);
        var $defaultValues = {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            infinite: false,
            fade: false,
            speed: 400,
            prevArrow: $('.carousel-control-prev', this),
            nextArrow: $('.carousel-control-next', this),
            customPaging: function (slider, i) {
                return `<span class="button" type="button" id="slick-slide-control0${i}" aria-controls="slick-slide0${i}" tabindex="${i === 0 ? 0 : -1}" role="tab" aria-label="Slide ${i + 1} of ${slider.slideCount}">${i + 1}</span>`;
            }
        };
        var $responsiveValues = {
            dots: true,
            arrows: false,
            draggable: true
        };
        slickSlider.init(selector, $defaultValues, $responsiveValues);

        return true;
    });
}

/**
 * appends params to a url
 * @param {string} url - Original url
 * @param {Object} params - Parameters to append
 * @returns {string} result url with appended parameters
 */
function appendToUrl(url, params) {
    var newUrl = url;
    newUrl += (newUrl.indexOf('?') !== -1 ? '&' : '?') + Object.keys(params).map(function (key) {
        return key + '=' + encodeURIComponent(params[key]);
    }).join('&');

    return newUrl;
}

function updateMiniCartCount(count) {
    $('.minicart-quantity').empty().append(count < 100 ? count : 99);
}

/**
 * Checks whether the basket is valid. if invalid displays error message and disables
 * checkout button
 * @param {Object} data - AJAX response from the server
 */
function validateBasket(data) {
    if (data.valid.error) {
        if (data.valid.message) {
            var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
                'fade show" role="alert">' +
                '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
                '<span aria-hidden="true">&times;</span>' +
                '</button>' + data.valid.message + '</div>';

            if ($('.valid-cart-error').length === 0) {
                $('.cart-error-msg').append(errorHtml);
            }
        } else {
            var cartSelector = $('.cart');
            cartSelector.removeClass('cart cart-page');
            cartSelector.addClass('cart-empty');
            if ($('.user.my-account').length > 0) {
                cartSelector.empty().append('<div class="row"> ' +
                    '<div class="col-12 text-center"> ' +
                    '<h1>' + data.basket.resources.emptyCartMsg + '</h1> ' +
                    '</div>' +
                    '</div>' +
                    '<div class="row"> ' +
                    '<div class="col-12 text-center btns"> ' +
                    '<a class="btn btn-primary browse-product" aria-label = ' + data.basket.resources.productBrowseMsg + ' href = ' + data.basket.actionUrls.productBrowseUrl + '>'
                    + data.basket.resources.productBrowseMsg + '</a> ' +
                    '</div> ' +
                    '</div> ' +
                    '<div class="content-asset"> ' +
                    data.basket.contactUsHtml +
                    '</div> '
                );
            } else {
                cartSelector.empty().append('<div class="row"> ' +
                    '<div class="col-12 text-center"> ' +
                    '<h1>' + data.basket.resources.emptyCartMsg + '</h1> ' +
                    '</div>' +
                    '</div>' +
                    '<div class="row"> ' +
                    '<div class="col-12 text-center btns"> ' +
                    '<a class="btn btn-secondary sign-in" aria-label = ' + data.basket.resources.signinMsg + '  href = ' + data.basket.actionUrls.signinUrl + '>'
                     + data.basket.resources.signinMsg + '</a> ' +
                    '<a class="btn btn-primary browse-product" aria-label = ' + data.basket.resources.productBrowseMsg + ' href = ' + data.basket.actionUrls.productBrowseUrl + '>'
                    + data.basket.resources.productBrowseMsg + '</a> ' +
                    '</div> ' +
                    '</div> ' +
                    '<div class="content-asset"> ' +
                    data.basket.contactUsHtml +
                    '</div> '
                );
            }
            $('.number-of-items').empty().append(data.resources.numberOfItems);
            focusHelper.announceCartItemsCount(data.resources.numberOfItems);
            updateMiniCartCount(data.numItems);
            var miniCartURL = '';
            if (data.numItems > 0) {
                $('.minicart-quantity').removeClass('no-quantity-items');
                $('.minicart-flyout').removeClass('empty-cart');
                miniCartURL = $('.minicart .minicart-link').data('url');
            } else {
                $('.minicart-quantity').addClass('no-quantity-items');
                $('.minicart-flyout').addClass('empty-cart');
                if (breakpoints.isDesktopView()) {
                    miniCartURL = '#';
                }
            }
            if (data.valid.hasInventoryError && data.numItems === data.valid.outofstockItems) {
                $('.minicart-link').attr('data-inventory-error', 'true');
            } else {
                $('.minicart-link').attr('data-inventory-error', 'false');
            }
            $('.minicart-link').attr({
                'aria-label': data.resources.minicartCountOfItems,
                title: data.resources.minicartCountOfItems,
                href: miniCartURL
            });
            $('.minicart .popover').empty();
            $('.minicart .popover').removeClass('show');
        }
        $('.checkout-btn').toggleClass('disabled', !data.valid.hasInventoryError);
    } else {
        $('.checkout-btn').removeClass('disabled');
    }
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} data - AJAX response from the server
 * @param {number} announceDelay - Optional delay for announcing cart items count, or null to skip announcement
 */
function updateCartTotals(data, announceDelay) {
    $('.number-of-items').empty().append(data.resources.numberOfItems);
    // Only announce if announceDelay is not explicitly null (allows skipping announcement)
    if (announceDelay !== null) {
        focusHelper.announceCartItemsCount(data.resources.numberOfItems, announceDelay);
    }
    $('.shipping-cost').empty().append(data.totals.totalShippingCost);
    $('.tax-total').empty().append(data.totals.totalTax);
    $('.grand-total-sum').empty().append(data.totals.grandTotal);

    var grandTotalContainer = $('.order-summary-container .card.order-total-summary .grand-total');
    if (!grandTotalContainer || grandTotalContainer.length === 0) {
        $('.grand-total').empty().append(data.totals.grandTotal);
    }
    $('.grand-total .processed-order-total').empty().append(data.totals.grandTotal);
    if (data.totals.subTotalWithGiftPurchases) {
        $('.minicart-footer .sub-total').empty().append(data.totals.subTotalWithGiftPurchases);
    } else {
        $('.minicart-footer .sub-total').empty().append(data.totals.subTotal);
    }
    $('.sub-total').not('.minicart-footer .sub-total').empty().append(data.totals.subTotal);
    updateMiniCartCount(data.numItems);
    if (data.totals.subTotalWithGiftPurchases && $('.giftcertificate-item').length > 0) {
        $('.sub-total').empty().append(data.totals.subTotalWithGiftPurchases);
    }
    if (data.totals.giftCardTotal && data.totals.giftCardTotal.value > 0) {
        $('.giftcertificate-item .sub-total').empty().append(data.totals.giftCardTotal.formatted);
        $('.order-totals .giftcertificate-item').removeClass('d-none');
    } else {
        $('.giftcertificate-item .sub-total').empty();
        $('.order-totals .giftcertificate-item').addClass('d-none');
    }
    var miniCartURL = '';
    if (data.numItems > 0) {
        $('.minicart-quantity').removeClass('no-quantity-items');
        $('.minicart-flyout').removeClass('empty-cart');
        miniCartURL = $('.minicart .minicart-link').data('url');
    } else {
        $('.minicart-quantity').addClass('no-quantity-items');
        $('.minicart-flyout').addClass('empty-cart');
        if (breakpoints.isDesktopView()) {
            miniCartURL = '#';
        }
    }
    $('.minicart-link').attr({
        'aria-label': data.resources.minicartCountOfItems,
        title: data.resources.minicartCountOfItems,
        href: miniCartURL
    });
    if (data.totals.productLevelDiscountTotal.value > 0) {
        $('.product-discount').removeClass('d-none');
        $('.product-discount-total').empty()
            .append('- ' + data.totals.productLevelDiscountTotal.formatted);
    } else {
        $('.product-discount').addClass('d-none');
    }
    if (data.totals.bounsProductDiscountTotal.value > 0) {
        $('.bouns-product-discount').removeClass('d-none');
        $('.bouns-product-discount-total').empty()
            .append('- ' + data.totals.bounsProductDiscountTotal.formatted);
    } else {
        $('.bouns-product-discount').addClass('d-none');
    }
    if (data.totals.orderLevelDiscountTotal.value > 0) {
        $('.order-discount').removeClass('hide-order-discount');
        $('.order-discount-total').empty()
            .append('- ' + data.totals.orderLevelDiscountTotal.formatted);
    } else {
        $('.order-discount').addClass('hide-order-discount');
    }
    if (data.totals.shippingLevelDiscountTotal.value > 0 &&
        data.totals.shippingLevelDiscountTotal.formatted !== data.totals.totalShippingCost) {
        $('.shipping-discount').removeClass('hide-shipping-discount');
        $('.shipping-discount-total').empty().append('- ' +
            data.totals.shippingLevelDiscountTotal.formatted);
    } else {
        $('.shipping-discount').addClass('hide-shipping-discount');
    }
    if (data.totals.shippingLevelDiscountTotal.value > 0 &&
        data.totals.shippingLevelDiscountTotal.formatted === data.totals.totalShippingCost) {
        $('.free-shipping-discount').removeClass('d-none');
        $('.shipping-cost').each(function () {
            var cost = $(this).find('s').text().trim() || $(this).text().trim();
            $(this).addClass('strike-through')
                .html('<span class="sr-only">Old shipping cost: </span><s>' + cost + '</s>');
        });
    } else {
        $('.free-shipping-discount').addClass('d-none');
        $('.shipping-cost').each(function () {
            var cost = $(this).find('s').text().trim() || $(this).text().trim();
            $(this).removeClass('strike-through').text(cost);
        });
    }
    if (data.totals.giftWrapPrice !== '-') {
        $('.gift-wrap-item').removeClass('d-none');
        $('.gift-wrap-total').empty().append(data.totals.giftWrapPrice);
    } else {
        $('.gift-wrap-item').addClass('d-none');
        $('.gift-wrap-total').empty();
    }

    if (data.isShippingAddress && $('.cart-page').length === 0) {
        $('.cart-tax-msg').text(data.resources.taxMsg);
        $('.cart-total-msg').text(data.resources.totalMsg);
    }
    data.items.forEach(function (item) {
        if (item.renderedPromotions) {
            $('.item-' + item.UUID).empty().append(item.renderedPromotions);
        } else {
            $('.item-' + item.UUID).empty();
        }
        if (item.priceTotal && item.priceTotal.renderedPrice) {
            $('.item-total-' + item.UUID).empty().append(item.priceTotal.renderedPrice);
        }
    });
    var firstComponent = $('.storepage .experience-region.experience-main').children('div').first();
    if (data.promoLimitReachedMsg) {
        $('.pga-customer-limit').removeClass('d-none');

        if (firstComponent.is('[class*="editorialRichText"]')) {
            firstComponent.addClass('d-none');
        }
    } else {
        $('.pga-customer-limit').addClass('d-none');

        if (firstComponent.is('[class*="editorialRichText"]')) {
            firstComponent.removeClass('d-none');
        }
    }
    if (data.shipments) {
        data.shipments.forEach(function (shipment) {
            if (shipment.selectedShippingMethodObj && shipment.selectedShippingMethodObj.freeShippingThresholdMessage) {
                var $freeShippingIndicator = $('.free-shipping-indicator');
                if ($freeShippingIndicator.length) {
                    var progressPercent = shipment.selectedShippingMethodObj.progressPercent;
                    var $freeShippingMessage = $freeShippingIndicator.find('.freeShippingThresholdMessage');

                    $freeShippingMessage
                        .text(shipment.selectedShippingMethodObj.freeShippingThresholdMessage)
                        .toggleClass('brand-darker-gray', progressPercent === 100);

                    $freeShippingIndicator
                        .find('.progress-bar')
                        .css('width', progressPercent + '%')
                        .attr('aria-valuenow', progressPercent);
                }
            }
        });
    }

    promoProgressBar.initTooltip();
}

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error-msg').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">'
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    $('.availability-' + lineItem.UUID).empty();

    var inStockDate = lineItem.availability && lineItem.availability.inStockDate ? Date.parse(lineItem.availability.inStockDate) : null;
    if (lineItem.availability && lineItem.availability.inStockDate && inStockDate > Date.now() && $('.line-item-availability').length > 0) {
        messages += '<div class="line-item-availability-content">';

        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach(function (message) {
                messages += '<p class="line-item-attributes mb-0">' + message + '</p>';
            });
        }

        messages += '<p class="line-item-attributes line-item-instock-date mb-0">'
            + $('.line-item-availability').data('msg').replace('{0}', lineItem.availability.inStockDate)
            + '</p>';

        messages += '</div>';
    }

    $('.availability-' + lineItem.UUID).html(messages);
}

/**
 * Finds an element in the array that matches search parameter
 * @param {array} array - array of items to search
 * @param {function} match - function that takes an element and returns a boolean indicating if the match is made
 * @returns {Object|null} - returns an element of the array that matched the query.
 */
function findItem(array, match) {
    for (var i = 0, l = array.length; i < l; i++) {
        if (match.call(this, array[i])) {
            return array[i];
        }
    }
    return null;
}

/**
 * Updates details of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateProductDetails(data, uuid) {
    var lineItem = findItem(data.cartModel.items, function (item) {
        return item.UUID === uuid;
    });

    var wrapper = $('.uuid-' + lineItem.UUID);
    var OOTSModal = wrapper.closest('.oots-items');

    if (OOTSModal.length) {
        var numberOfOOTS = OOTSModal.find('.product-summary .card:visible').length;
        if (numberOfOOTS === 1) {
            $('.remove-and-process span').trigger('click');
            setTimeout(function () {
                $.spinner().start();
            }, 100);
        }
        wrapper.addClass('h-0');
        setTimeout(function () {
            wrapper.remove();
        }, 300);
        var $errorMsg = $('.minicart-footer .inventory-error-msg');
        if (numberOfOOTS === 1) {
            $errorMsg.text($errorMsg.data('msg-item'));
        } else if (numberOfOOTS) {
            var message = $errorMsg.data('msg-items').replace('#', numberOfOOTS - 1);
            $errorMsg.text(message);
        }
    }

    if (lineItem.variationAttributes) {
        for (var i = 0; i < lineItem.variationAttributes.length; i++) {
            var attr = lineItem.variationAttributes[i];
            var attributeId = attr.attributeId;
            var newAttr;
            var dataAttr;

            if (attributeId) {
                var attrClass = attr.displayName;
                var attrSelector = '.' + attrClass + '-' + uuid;
                if (attributeId === 'size' && data.currentSiteId && data.currentSiteId.toLowerCase().indexOf('uk') > -1 && !isNaN(attr.displayValue) && !isNaN(lineItem.sizeDifference)) {
                    var UKSize = Number(attr.displayValue) - Number(lineItem.sizeDifference);
                    dataAttr = 'UK ' + UKSize;
                } else {
                    dataAttr = attr.displayValue;
                }

                var isEgcAmount = lineItem.isEGiftCard && attributeId.toLowerCase() === 'amount';
                var attrName = isEgcAmount ? $('.line-item-attributes.value .attribute-label').text().split(':')[0].trim() : attr.displayName;
                if (lineItem.isEGiftCard && isEgcAmount && lineItem.egcCustomAmount) {
                    dataAttr = lineItem.formattedEgcAmount;
                }
                newAttr = `<span class="attribute-label">${attrName}: </span> <span>${dataAttr}</span>`;
                var index = lineItem.variationAttributes.length - 1;
                if (i < index) {
                    newAttr += '<span class="attribute-label-divider">&#47;</span>';
                }

                if (lineItem.isEGiftCard) {
                    $(attrSelector + '.d-sm-block').html(newAttr);
                    $(attrSelector + '.d-sm-block').attr('data-displayvalue', dataAttr);

                    $(attrSelector + '.d-sm-none').html(dataAttr);
                    $(attrSelector + '.d-sm-none').attr('data-displayvalue', dataAttr);
                } else {
                    $(attrSelector).html(newAttr);
                    $(attrSelector).attr('data-displayvalue', dataAttr);
                }
            }
        }

        var imageSelector = '.card.product-info.uuid-' + uuid + ' .item-image img';
        $(imageSelector).attr('src', lineItem.images.pli[0].url);
        $(imageSelector).attr('alt', lineItem.images.pli[0].alt);
        $(imageSelector).attr('title', lineItem.images.pli[0].title);
    }


    var styleNumberSelector = $('.card.product-info.uuid-' + uuid + ' .line-item-sku span.style-number');
    if (styleNumberSelector.length && lineItem.manufacturerSKU) {
        styleNumberSelector.text(lineItem.manufacturerSKU);
    }

    if (lineItem.options && lineItem.options.length) {
        var optSelector = null;
        if (lineItem.embroidery.isEmbroidery) {
            optSelector = '.lineItem-options-values[data-uuid="' + uuid + '"]';
            var prefix = lineItem.embroidery.enable ? ($('.options-values-' + uuid).data('embroidery-prefix') || '') : '';
            if ($(optSelector).length > 0) {
                $(optSelector).data('value-id', lineItem.embroidery.enable ? 'yes' : 'no');
                $(optSelector + ' .line-item-attributes').text(prefix + ' ' + lineItem.embroidery.text);
            } else {
                $('.options-values-' + uuid).append('<div class="lineItem-options-values" data-option-id="embroidery" data-value-id="yes" ' +
                            'data-uuid="' + uuid + '" > ' +
                            '<p class="line-item-attributes"> ' +
                            prefix + ' ' +
                            lineItem.embroidery.text +
                            '</p>' +
                            '</div>'
                        );
            }
        } else {
            var option = lineItem.options[0];
            optSelector = '.lineItem-options-values[data-option-id="' + option.optionId + '"]';
            $(optSelector).data('value-id', option.selectedValueId);
            $(optSelector + ' .line-item-attributes').text(option.displayName);
        }
    }

    if (lineItem.isEGiftCard) {
        $('.recipient-email-' + lineItem.UUID).empty().html(lineItem.egiftCardRecipientEmail);
        $('.gift-message-' + lineItem.UUID).empty();
        if (lineItem.egiftCardMessage) {
            $('.gift-message-' + lineItem.UUID).empty().append(lineItem.egiftCardMessage);
            $('.gift-message-wrapper-' + lineItem.UUID).removeClass('d-none');
        } else {
            $('.gift-message-wrapper-' + lineItem.UUID).addClass('d-none');
        }
        if (lineItem.formattedEgcAmount) {
            $('.Amount-' + lineItem.UUID + ' span:not(.attribute-label), .Value-' + lineItem.UUID + ' span:not(.attribute-label)').text(lineItem.formattedEgcAmount);
        }
    }

    var qtySelector = '.quantity[data-uuid="' + uuid + '"]';
    $(qtySelector).val(lineItem.quantity);
    $(qtySelector).data('pid', data.newProductId);
    $('.quantity-value[data-uuid="' + uuid + '"]').text(lineItem.quantity);

    $('.remove-product[data-uuid="' + uuid + '"]').data('pid', data.newProductId);

    var priceSelector = '.line-item-price-' + uuid + ' .sales .value';
    $(priceSelector).text(lineItem.price.sales.formatted);
    $(priceSelector).attr('content', lineItem.price.sales.decimalPrice);

    if (lineItem.price.list) {
        var listPriceSelector = '.line-item-price-' + uuid + ' .list .value';
        $(listPriceSelector).text(lineItem.price.list.formatted);
        $(listPriceSelector).attr('content', lineItem.price.list.decimalPrice);
    }
}

/**
 * Updates cart items section
 * @param {Object} data - AJAX response from the server
 */
function updateCartItems(data) {
    if (data && data.cartItemsHtml) {
        var $newCartItems = $('<div>' + data.cartItemsHtml + '</div>');
        var $newCartItemsWrapper = $newCartItems.find('.cart-items-wrapper');
        if ($newCartItemsWrapper.length > 0) {
            var $cartItemsWrapper = $('.cart-items-wrapper');
            if ($cartItemsWrapper.length > 0) {
                $cartItemsWrapper.replaceWith($newCartItemsWrapper);
            }
        } else {
            var $miniCartProductSummary = $('.minicart .product-summary');
            if ($miniCartProductSummary.length > 0) {
                $miniCartProductSummary.html($(data.cartItemsHtml));
            }
        }
    }
}

/**
 * replace content of modal
 * @param {string} actionUrl - url to be used to remove product
 * @param {string} productID - pid
 * @param {string} productName - product name
 * @param {string} uuid - uuid
 */
function confirmDeleteForHazmat(actionUrl, productID, productName, uuid) {
    var $deleteConfirmBtn = $('.hazmat-cart-delete-confirmation-btn');
    var $productToRemoveSpan = $('.hazmat-product-to-remove');

    $deleteConfirmBtn.data('pid', productID);
    $deleteConfirmBtn.data('action', actionUrl);
    $deleteConfirmBtn.data('uuid', uuid);

    $productToRemoveSpan.empty().append(productName);
}

function initRecommendationSlider() {
    var selectors = $('.pdp-recommendations__tiles-container--slider, .recommendation-body--slider');
    if (!selectors.length) return;

    selectors.each(function () {
        var selector = $(this);
        var slidesToShow = 3.4;
        var slidesToShowTablet = 3.4;
        var slidesToShowMobile = 2.8;

        if (selector.hasClass('slick-initialized')) {
            return;
        }

        if (selector.closest('.cart-sheet.pid').length) {
            // added to cart sheet
            slidesToShow = 2.5;
            slidesToShowTablet = 2.5;
            slidesToShowMobile = 2.5;
        } else if (selector.closest('.cart-sheet').length) {
            // minicart sheet
            slidesToShow = 3.5;
        } else if (selector.closest('.slot-product-carousel').length) {
            slidesToShow = 4;
        }

        slickSlider.init(selector, {
            slidesToShow: slidesToShow,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            infinite: false,
            fade: false,
            speed: 400,
            accessibility: true,
            prevArrow: '<button type="button" class="slide-arrow prev-arrow" aria-label="Previous slide"><span class="svg-left-arrow"></span><span class="sr-only">Previous</span></button>',
            nextArrow: '<button type="button" class="slide-arrow next-arrow" aria-label="Next slide"><span class="svg-right-arrow"></span><span class="sr-only">Next</span></button>',
            responsive: [
                {
                    breakpoint: 992,
                    settings: {
                        slidesToShow: slidesToShowTablet,
                        draggable: true
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: slidesToShowMobile,
                        draggable: true
                    }
                }
            ]
        });
    });
}

function updateIsHazardousProducts(isHazardousProducts) {
    if (isHazardousProducts) {
        $('#isHazardousProducts').val(true);
    } else {
        $('#isHazardousProducts').val(false);
    }
}

function showItemRemovedNotification(data, uuid) {
    let timer;
    let notification;
    if (data.removedItemNotificationHtml) {
        $('.item-removed-notification-wrapper').append(data.removedItemNotificationHtml);
        notification = $('.item-removed-notification.notification-uuid-' + uuid);
        setTimeout(() => {
            notification.addClass('show').toggleClass('mt-n2', $('.cart-page .cart-items-wrapper').length > 0);
            notification.find('.undo-btn').focus();
        }, 10);
    }
    let url = $('.action-btns .show-cart-ajax').val();
    timer = setTimeout(() => {
        notification.find('.dismiss-btn').trigger('click');
        notification.removeClass('show');
        setTimeout(() => {
            notification.remove();
        }, 500);
    }, 5000);

    notification.on('mouseenter', () => clearTimeout(timer));
    notification.on('mouseleave', () => {
        timer = setTimeout(() => {
            notification.find('.dismiss-btn').trigger('click');
            notification.removeClass('show');
            setTimeout(() => {
                notification.remove();
            }, 500);
        }, 3000);
    });
    // Undo logic
    notification.find('.undo-btn').on('click keydown', function (e) {
        if (!(e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter')) || isUndoAjaxInProgress) {
            return;
        }
        clearTimeout(timer);
        notification.removeClass('show');
        setTimeout(() => {
            notification.remove();
        }, 500);
        isUndoAjaxInProgress = true;

        $.ajax({
            url: url,
            type: 'GET',
            success: function (res) {
                $('.sticky-cart-footer').removeClass('d-none');
                $('.coupons-and-promos').empty().append(res.cart.totals.discountsHtml);
                if (res.cart.isImplicPromo) {
                    $('.implicitPromoDisplay').removeClass('d-none');
                } else {
                    $('.implicitPromoDisplay').addClass('d-none');
                }
                updateCartTotals(res.cart);
                validateBasket(res.cart);
                updateApproachingDiscounts(res.cart.approachingDiscounts);
                $('body').trigger('cart:update');
                $('.uuid-' + uuid).removeClass('h-0');
                $('.minicart').trigger('count:update', res.cart);
                updateIsHazardousProducts(res.isHazardousProducts);
                $.spinner().stop();
                isUndoAjaxInProgress = false;
            },
            error: function () {
                isUndoAjaxInProgress = false;
                window.console.error('Failed to restore item');
            }
        });
    });

    // Dismiss logic
    notification.find('.dismiss-btn').on('click keydown', function (e) {
        if (!(e.type === 'click' || (e.type === 'keydown' && e.key === 'Enter'))) {
            return;
        }
        notification.removeClass('show');
        e.preventDefault();
        setTimeout(() => {
            notification.remove();
        }, 500);
    });
}

function removeProductLineItem(url, uuid, isFake, productId) {
    if (isFake === false && !removeUrlCooldownMap.has(url)) {
        removeUrlCooldownMap.add(url);
    } else if (isFake === false && removeUrlCooldownMap.has(url)) {
        return;
    }
    $.spinner().start();
    $.ajax({
        url: url,
        type: 'get',
        dataType: 'json',
        success: function (data) {
            const executeFinalRemovalUIUpdates = () => {
                const targetElement = $('.uuid-' + uuid);
                if (isFake) {
                    targetElement.addClass('h-0');
                } else {
                    targetElement.addClass('d-none');
                }

                var removedItemId = $('.container.product-detail').data('pid');

                // eslint-disable-next-line no-param-reassign
                data.basket.isFake = isFake;
                const showNotification = !targetElement.find('.oot-js-msg').length && isFake;

                if (data.basket.items.length === 0) {
                    $('.number-of-items').empty().append(data.basket.resources.numberOfItems);
                    // Announce empty cart with delay to allow DOM to stabilize
                    focusHelper.announceCartItemsCount(data.basket.resources.numberOfItems, 300);
                    if (!isFake) $('.sticky-cart-footer').addClass('d-none');
                    updateMiniCartCount(data.basket.numItems);
                    if (
                        $('.cart-header.inventory-error').length
                        && data.basket.actionUrls.moveToCart) {
                        window.location.href = data.basket.actionUrls.moveToCart;
                    }
                    if (!isFake) {
                        $('.cart-empty-wrapper').removeClass('d-none');
                        $('.cart-page').empty();
                        $('.mini-cart-page-empty').removeClass('d-none');
                        $('.mini-cart-page').empty();
                    }

                    if ((removedItemId && productId) && productId.toString() === removedItemId) {
                        $('.quantity .quantity-select').removeAttr('disabled');
                    }
                } else {
                    if (
                        $('.cart-header.inventory-error').length
                        && !data.basket.valid.hasInventoryError
                        && data.basket.actionUrls.moveToCheckout) {
                        window.location.href = data.basket.actionUrls.moveToCheckout;
                    }

                    if (!data.basket.valid.outofstockItems) {
                        $('.js-cart-oot-items').removeClass('js-cart-oot-items');
                    }

                    if (!data.basket.hasBonusProduct) {
                        $('.bonus-product').remove();
                    }
                    if (!isFake && data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            var deletedUUID = data.toBeDeletedUUIDs[i];
                            $('.uuid-' + deletedUUID).addClass('h-0');
                            // eslint-disable-next-line no-loop-func
                            setTimeout(function () {
                                $('.uuid-' + deletedUUID).remove();
                            }, 300);
                        }
                    }
                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    // Pass null to skip announcement in updateCartTotals (we'll announce explicitly below)
                    updateCartTotals(data.basket, null);
                    updateCartItems(data);
                    updateApproachingDiscounts(data.basket.approachingDiscounts);
                    if (data.basket.isImplicPromo) {
                        $('.implicitPromoDisplay').removeClass('d-none');
                    } else {
                        $('.implicitPromoDisplay').addClass('d-none');
                    }

                    if ((removedItemId && productId) && productId.toString() === removedItemId) {
                        $('.quantity .quantity-select').removeAttr('disabled');
                    }

                    // Delay progress bar announcement to ensure it comes after other announcements
                    if (data.promoProgressBar) {
                        promoProgressBar.handle(data.promoProgressBar, 600);
                    }

                    $('body').trigger('setShippingMethodSelection', data.basket);
                    validateBasket(data.basket);
                }

                updateIsHazardousProducts(data.isHazardousProducts);

                $('body').trigger('cart:update');
                $('.minicart').trigger('count:update', data.basket);
                if (showNotification) showItemRemovedNotification(data, uuid);

                // Only announce item count for REAL removals (not fake/undo removals)
                // Announce AFTER undo notification is fully rendered and focus has changed
                if (!isFake && data.basket.resources && data.basket.resources.numberOfItems) {
                    focusHelper.announceCartItemsCount(data.basket.resources.numberOfItems, 300);
                }
                $('.card.product-info:visible').not('.h-0')
                .removeClass('last-card').last()
                .addClass('last-card');


                $.spinner().stop();

                if (data.basket.numItems > 0) {
                    $('.cart-page div.card.product-info:last').addClass('last-card');
                }

                if (data.gtmDataLayer) {
                    window.dataLayer = window.dataLayer || [];
                    for (var ind = 0; ind < data.gtmDataLayer.length; ind++) {
                        window.dataLayer.push(data.gtmDataLayer[ind]);
                    }
                }
                setTimeout(() => {
                    removeUrlCooldownMap.delete(url);
                }, 5000);
            };

            if (isFake) {
                executeFinalRemovalUIUpdates();
            } else {
                const $miniCartPopover = $('.minicart .popover');
                const $popover = $miniCartPopover.get(0);

                if (!$popover) {
                    return;
                }

                if (!$miniCartPopover.hasClass('loading')) {
                    executeFinalRemovalUIUpdates();

                    return;
                }

                const observer = new MutationObserver(() => {
                    window.console.log('CLASS LIST: ', $miniCartPopover.attr('class'));
                    if (!$miniCartPopover.hasClass('loading')) {
                        observer.disconnect();
                        executeFinalRemovalUIUpdates();
                    }
                });

                observer.observe($popover, {
                    attributes: true,
                    attributeFilter: ['class']
                });
            }
        },
        error: function (err) {
            if (err.responseJSON.redirectUrl) {
                window.location.href = err.responseJSON.redirectUrl;
            } else {
                createErrorNotification(err.responseJSON.errorMessage);
                $.spinner().stop();
            }
            setTimeout(() => {
                removeUrlCooldownMap.delete(url);
            }, 5000);
        }
    });
}

let lastScrollTop = 0;
let subtotalItemHidden = false;
let animationFrame;
let isProgrammaticScroll = false;

function programmaticScrollTo(position) {
    isProgrammaticScroll = true;

    window.scrollTo({
        top: position,
        behavior: 'smooth'
    });

    setTimeout(() => {
        isProgrammaticScroll = false; // Re-enable manual scrolling
    }, 500);
}

/**
 * Handles scroll and sticky footer behavior
 */
function handleScroll() {
    const stickyFooter = document.querySelector('.sticky-cart-footer.totals');
    const cartContainer = document.querySelector('#maincontent');
    const orderTotalsWrapper = document.querySelector('.order-totals-wrapper');
    const subtotalItem = document.querySelector('.totals-entry.subtotal-item-sticky'); // Target subtotal line

    if (isProgrammaticScroll || window.innerWidth >= utils.breakpoints.md || !stickyFooter || !cartContainer || !orderTotalsWrapper || !subtotalItem) return;

    const containerRect = cartContainer.getBoundingClientRect();
    const stickyFooterRect = stickyFooter.getBoundingClientRect();
    const wrapperRect = orderTotalsWrapper.getBoundingClientRect();
    const viewportHeight = window.innerHeight; // Viewport height
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollingDown = currentScrollTop > lastScrollTop; // Determine scroll direction

    // Check conditions for trigger
    const stickyFooterAtBottom = stickyFooterRect.bottom >= viewportHeight;
    const containerReachedBottom = containerRect.bottom - 380 <= viewportHeight;
    const wrapperAlignedWithContainer = wrapperRect.top + 380 > containerRect.bottom;
    const triggerCondition = stickyFooterAtBottom && containerReachedBottom && wrapperAlignedWithContainer;
    const isBottomReached = window.innerHeight + window.scrollY >= document.documentElement.scrollHeight;
    cancelAnimationFrame(animationFrame);

    if ((triggerCondition && scrollingDown) || isBottomReached) {
        // Trigger animations when the sticky footer reaches the bottom of the viewport and container is in view
        animationFrame = requestAnimationFrame(() => {
            if (scrollingDown && !subtotalItemHidden) {
                setTimeout(() => {
                    subtotalItem.style.transition = 'opacity 0.3s ease-in-out, margin-bottom 0.2s ease-in-out';
                    subtotalItem.style.opacity = '0'; // Fade out
                    subtotalItem.style.marginBottom = '-120px'; // Collapse
                    subtotalItemHidden = true;
                    isProgrammaticScroll = true;
                }, 100); // Delay for 0.1 seconds

                // Expand orderTotalsWrapper
                const wrapperHeight = orderTotalsWrapper.scrollHeight;
                orderTotalsWrapper.style.transition = 'min-height 0.3s ease-in-out';
                orderTotalsWrapper.style.minHeight = `${wrapperHeight}px`;

                // mainContent min-height
                setTimeout(() => {
                    programmaticScrollTo(document.body.scrollHeight);
                }, 50); // Delay subtotal item return
            }
        });
    } else if (!scrollingDown && subtotalItemHidden) {
        // Reset when sticky footer is not at the bottom or container not in view
        animationFrame = requestAnimationFrame(() => {
            orderTotalsWrapper.style.transition = 'min-height 0.3s ease-in-out';
            orderTotalsWrapper.style.minHeight = '0px'; // Collapse the wrapper

            setTimeout(() => {
                subtotalItem.style.transition = 'opacity 0.3s ease-in-out, margin-bottom 0.3s ease-in-out';
                subtotalItem.style.opacity = '1'; // Fade in
                subtotalItem.style.marginBottom = '0'; // Expand
                subtotalItemHidden = false;
            }, 200); // Delay subtotal item return by 0.2s
        });
    }

    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Avoid negative values
}

/**
 * Updates the `min-height` of the `.order-totals-wrapper` element
 * to match its full scrollable content height.
 */
function updateOrderTotalsMinHeight() {
    const wrapper = document.querySelector('.order-totals-wrapper');
    if (!wrapper) return;

    wrapper.style.minHeight = '0px';

    // Trigger reflow to ensure the height is recalculated
    wrapper.style.display = 'none';
    wrapper.offsetHeight; // eslint-disable-line no-unused-expressions
    wrapper.style.display = '';

    const height = wrapper.scrollHeight;
    wrapper.style.minHeight = height + 'px';
}

function handleApplePayErrors() {
    if ((sessionStorage.getItem('stateCodeFromApplePay') === 'AK' || sessionStorage.getItem('stateCodeFromApplePay') === 'HI') && $('#isHazardousProducts').val() === 'true') {
        $('#hazardousModal').modal('show');
        sessionStorage.removeItem('stateCodeFromApplePay');
    }
    if (sessionStorage.getItem('countryIsGlobale') !== null) {
        shippingHelpers.methods.handleGlobaleCountry(sessionStorage.getItem('countryIsGlobale'));
        sessionStorage.removeItem('countryIsGlobale');
    }
    if (sessionStorage.getItem('countryIsNotValid') !== null) {
        $('.express-error-msg').removeClass('d-none');
        sessionStorage.removeItem('countryIsNotValid');
    }
    if (sessionStorage.getItem('applepayDataErrors') !== null) {
        var applepayDataErrors = sessionStorage.getItem('applepayDataErrors');
        if (applepayDataErrors.length) {
            $('.express-data-error-msg .error-fields').text(applepayDataErrors);
            $('.express-data-error-msg').removeClass('d-none');
        }
        sessionStorage.removeItem('applepayDataErrors');
    }
}

/**
 * Opens the GlobalE country switcher and preselects
 * country and currency based on url paramaters
 * @param {string} countryCode - optional country code string
 * @param {string} currencyCode - optional currency code string
 */
function handleGlobaleCountrySwitcher(countryCode, currencyCode) {
    var maxIntervals = 20;
    var checkGlobalE = setInterval(function () {
        if ('GlobalE' in window && 'ShippingSwitcher' in window.GlobalE) {
            clearInterval(checkGlobalE);

            var geCountry = null;
            var geCurrency = null;

            if (countryCode && currencyCode) {
                geCountry = countryCode;
                geCurrency = currencyCode;
            } else {
                var url = new URL(window.location.href);
                geCountry = url.searchParams.get('geCountryCode');
                geCurrency = url.searchParams.get('geCurrencyCode');
                if (geCountry || geCurrency) {
                    if (geCountry) url.searchParams.delete('geCountryCode');
                    if (geCurrency) url.searchParams.delete('geCurrencyCode');
                    window.history.replaceState(null, null, url);
                }
            }

            if (geCountry && geCurrency) {
                // remove parameters from 'data-querystring' in DOM
                var requestDataEl = document.querySelector('[data-action][data-querystring]');
                if (requestDataEl) {
                    var queryString = requestDataEl.getAttribute('data-querystring');
                    if (queryString && queryString.length) {
                        var queryParams = queryString.split('&').filter(function (queryParam) {
                            return !(queryParam.indexOf('geCountryCode') > -1 || queryParam.indexOf('geCurrencyCode') > -1);
                        });
                        queryString = queryParams.join('&');
                    }
                    requestDataEl.setAttribute('data-querystring', queryString);
                }
                $('.globale-selector').trigger('click');
                GlobalE.ShippingSwitcher.SetSelectedCountry(geCountry, false, geCurrency); // eslint-disable-line
                var $globaleCountrySelect = $('select#gle_selectedCountry');
                if ($globaleCountrySelect.length > 0) GlobalE.ShippingSwitcher.OnCountryChanged($globaleCountrySelect.get(0)); // eslint-disable-line
            }
        } else {
            window.console.log('Cannot open GlobalE country switcher: GlobalE not in window');
        }

        maxIntervals--;
        if (maxIntervals < 1) clearInterval(checkGlobalE);
    }, 200);
}

module.exports = function () {
    $('body').on('edit:slider', function () {
        setSlickSlider();
    });

    $('body').on('click keydown', '.remove-product', function (e) {
        if (e.type === 'click' || (e.type === 'keydown' && e.keyCode === 13)) {
            e.preventDefault();
            const productID = $(this).data('pid');
            const uuid = $(this).data('uuid');
            let url = $(this).data('action');
            let isFake = $(this).hasClass('is-fake');
            let isMiniCart = $(this).closest('.minicart').length > 0;

            const urlParams = {
                pid: productID,
                uuid: uuid,
                isFake: isFake,
                isMiniCart: isMiniCart
            };
            url = appendToUrl(url, urlParams);
            removeProductLineItem(url, uuid, isFake, productID);
            $('#hazardousModal').modal('hide');
        }
    });

    $('body').on('change', '.quantity-form > .quantity', function () {
        var preSelectQty = $(this).data('pre-select-qty');
        var quantity = $(this).val();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var isMiniCart = $(this).closest('.minicart').length > 0;

        var urlParams = {
            pid: productID,
            quantity: quantity,
            uuid: uuid,
            isMiniCart: isMiniCart
        };
        url = appendToUrl(url, urlParams);

        $(this).parents('.card').spinner().start();

        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                $('.quantity[data-uuid="' + uuid + '"]').val(quantity);
                $('.quantity-value[data-uuid="' + uuid + '"]').text(quantity);
                $('.quantity[data-uuid="' + uuid + '"]').siblings('.quantity-label').attr('aria-label', 'quantity: ' + quantity);
                $('.coupons-and-promos').empty().append(data.totals.discountsHtml);

                // Find the updated item to get its subtotal
                var updatedItem = null;
                for (var i = 0; i < data.items.length; i++) {
                    if (data.items[i].UUID === uuid) {
                        updatedItem = data.items[i];
                        break;
                    }
                }

                // Announce quantity change and subtotal together (happens at 100ms)
                var announcement = 'Quantity changed to ' + quantity;
                if (updatedItem && updatedItem.priceTotal && updatedItem.priceTotal.renderedPrice) {
                    announcement += ', item subtotal ' + updatedItem.priceTotal.renderedPrice;
                }
                focusHelper.announceQuantityChange(announcement);

                // Update cart totals with delayed announcement (happens at 300ms)
                updateCartTotals(data);
                updateCartItems(data);
                updateApproachingDiscounts(data.approachingDiscounts);
                updateAvailability(data, uuid);

                // Delay progress bar announcement to ensure it comes after qty/subtotal and item count (happens at 600ms)
                if (data.promoProgressBar) {
                    promoProgressBar.handle(data.promoProgressBar, 600);
                }
                validateBasket(data);
                var newQuantity = parseInt(quantity, 10);
                var maxQuantity = parseInt($(this).attr('max'), 10);
                var minQuantity = parseInt($(this).attr('min'), 10);
                $(this).data('pre-select-qty', quantity);

                if (maxQuantity <= newQuantity) {
                    $('.quantity[data-uuid="' + uuid + '"]').parent('.quantity-selector').find('.increase-qty-button').attr('disabled', 'disabled');
                } else {
                    $('.quantity[data-uuid="' + uuid + '"]').parent('.quantity-selector').find('.increase-qty-button').removeAttr('disabled');
                }

                if (newQuantity <= 1 || newQuantity <= minQuantity) {
                    $('.quantity[data-uuid="' + uuid + '"]').parent('.quantity-selector').find('.decrease-qty-button').attr('disabled', 'disabled');
                } else {
                    $('.product-detail .quantity-select').removeAttr('disabled');
                    $('.quantity[data-uuid="' + uuid + '"]').parent('.quantity-selector').find('.decrease-qty-button').removeAttr('disabled');
                }

                $('body').trigger('cart:update');
                $('.minicart').trigger('count:update', data);

                if (data.isImplicPromo) {
                    $('.implicitPromoDisplay').removeClass('d-none');
                } else {
                    $('.implicitPromoDisplay').addClass('d-none');
                }

                $.spinner().stop();
                if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                    location.reload();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $(this).val(parseInt(preSelectQty, 10));
                    $.spinner().stop();
                }
            }
        });
    });

    $('.shippingMethods').change(function () {
        var url = $(this).attr('data-actionUrl');
        var urlParams = {
            methodID: $(this).find(':selected').attr('data-shipping-id')
        };
        // url = appendToUrl(url, urlParams);

        $('.totals').spinner().start();
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: urlParams,
            success: function (data) {
                if (data.error) {
                    window.location.href = data.redirectUrl;
                } else {
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    updateCartTotals(data);
                    updateCartItems(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);

                    // Delay progress bar announcement to ensure it comes after other announcements
                    if (data.promoProgressBar) {
                        promoProgressBar.handle(data.promoProgressBar, 600);
                    }
                }
                $.spinner().stop();
            },
            error: function (err) {
                if (err.redirectUrl) {
                    window.location.href = err.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    // Add coupon code
    $('.promo-code-form').submit(function (e) {
        var $form = $(this);
        e.preventDefault();
        $.spinner().start();
        $form.find('.coupon-missing-error').empty();
        $form.find('.coupon-error-message').empty().attr('aria-live', 'off')
            .removeAttr('role')
            .removeAttr('aria-atomic');
        $form.removeClass('has-error');
        $('.error-message-icon').hide();
        if (!$(this).find('.coupon-code-field').val()) {
            $form.find('.form-control').addClass('is-invalid');
            var couponMissingText = $('#coupon-missing-error-sr').text();
            var $missingErrorContainer = $form.find('.coupon-error-message');
            // Set content first while aria-live is still "off"
            $missingErrorContainer.text(couponMissingText);
            // Then activate the live region with role="alert"
            setTimeout(function () {
                $missingErrorContainer.attr({
                    role: 'alert',
                    'aria-atomic': 'true'
                });
            }, 100);
            $form.find('.coupon-error .error-message-icon').show();
            $form.addClass('has-error');
            $.spinner().stop();
            return false;
        }
        $form.find('.form-control').removeClass('is-invalid');
        $form.find('.coupon-error-message').empty();

        $.ajax({
            url: $form.attr('action'),
            type: 'GET',
            dataType: 'json',
            data: $form.serialize(),
            success: function (data) {
                if (data.error) {
                    $form.find('.form-control').addClass('is-invalid');
                    var $invalidErrorContainer = $form.find('.coupon-error-message');
                    // Set content first while aria-live is still "off"
                    $invalidErrorContainer.empty().text(data.errorMessage);
                    // Then activate the live region with role="alert"
                    setTimeout(function () {
                        $invalidErrorContainer.attr({
                            role: 'alert',
                            'aria-atomic': 'true'
                        });
                    }, 100);
                    $form.addClass('has-error');
                    $('.order-summary .coupon-error-message').prevAll('.error-message-icon').first().show();
                    $('.order-totals-wrapper .coupon-error-message').prevAll('.error-message-icon').first().show();
                    $.spinner().stop();
                } else if ($('.card.product-info').length !== data.items.length) { // Number of items, not quantity
                    location.reload();
                } else {
                    updateCartTotals(data);
                    updateCartItems(data);
                    if (data.isImplicPromo) {
                        $('.implicitPromoDisplay').removeClass('d-none');
                    } else {
                        $('.implicitPromoDisplay').addClass('d-none');
                    }
                    $('.coupons-and-promos').empty().append(data.totals.discountsHtml);
                    $('.coupon-code-field').val('');
                    updateApproachingDiscounts(data.approachingDiscounts);

                    // Delay progress bar announcement to ensure it comes after other announcements
                    if (data.promoProgressBar) {
                        promoProgressBar.handle(data.promoProgressBar, 600);
                    }
                    var appliedCCLimitMax = $('.promo-code-form').data('appliedcclimitmax');
                    if (appliedCCLimitMax) {
                        var appliedCCLimitMaxInt = parseInt(appliedCCLimitMax, 10);
                        if (data.appliedCouponNumber >= appliedCCLimitMaxInt) {
                            $('.promo-code-form-fields').addClass('d-none');
                        } else {
                            $('.promo-code-form-fields').removeClass('d-none');
                        }
                    }
                    validateBasket(data);
                    updateOrderTotalsMinHeight();

                    if (data.ineligibleError) {
                        $form.find('.form-control').addClass('is-invalid');
                        var $ineligibleErrorContainer = $form.find('.coupon-error-message');
                        // Set content first while aria-live is still "off"
                        $ineligibleErrorContainer.empty().append(data.ineligibleError);
                        // Then activate the live region with role="alert"
                        setTimeout(function () {
                            $ineligibleErrorContainer.attr({
                                role: 'alert',
                                'aria-atomic': 'true'
                            });
                        }, 100);
                        $form.addClass('has-error');
                        $form.find('.coupon-error-message').prevAll('.error-message-icon').first().show();
                        $('.order-totals-wrapper .coupon-error-message').prevAll('.error-message-icon').first().show();
                    }
                    $.spinner().stop();
                }
                    // if (data.totals && data.totals.discounts) {
                    //     var couponDiscount = null;
                    //     data.totals.discounts.forEach(element => {
                    //         if (element.type === 'coupon') {
                    //             couponDiscount = element;
                    //         }
                    //     });
                    //     if (couponDiscount) {
                    //         $('.promo-code-form .promo-code-btn').addClass('d-none');
                    //         $('.promo-code-form .remove-coupon').removeClass('d-none');
                    //         $('.promo-code-form .remove-coupon').data('code', couponDiscount.couponCode);
                    //         $('.promo-code-form .remove-coupon').data('uuid', couponDiscount.UUID);
                    //         $('.promo-code-form .coupons-callout-msg').text(couponDiscount.callOutMsg);
                    //         $('.coupon-code-field').attr('disabled', 'disabled');
                    //     } else {
                    //         $('.promo-code-form .promo-code-btn').removeClass('d-none');
                    //         $('.promo-code-form .remove-coupon').addClass('d-none');
                    //         $('.promo-code-form .coupons-callout-msg').text('');
                    //         $('.coupon-code-field').removeAttr('disabled');
                    //     }
                    // }
                    // Reload the whole page if there are a different number of products.
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    if (err.responseJSON !== undefined && err.responseJSON.errorMessage !== undefined &&
                        err.responseJSON.errorMessage.length) {
                        $form.addClass('has-error');
                        $('.order-summary .coupon-error-message').prevAll('.error-message-icon').first().show();
                        $('.order-totals-wrapper .coupon-error-message').prevAll('.error-message-icon').first().show();
                        var $ajaxErrorContainer = $('.coupon-error-message');
                        // Set content first while aria-live is still "off"
                        $ajaxErrorContainer.empty().text(err.responseJSON.errorMessage);
                        // Then activate the live region with role="alert"
                        setTimeout(function () {
                            $ajaxErrorContainer.attr({
                                role: 'alert',
                                'aria-atomic': 'true'
                            });
                        }, 100);
                    }
                    $.spinner().stop();
                }
            }
        });
        return false;
    });

    $('body').on('click', '.remove-coupon', function (e) {
        e.preventDefault();

        var couponCode = $(this).data('code');
        var uuid = $(this).data('uuid');
        var $deleteConfirmBtn = $('.delete-coupon-confirmation-btn');
        var $productToRemoveSpan = $('.coupon-to-remove');

        $deleteConfirmBtn.data('uuid', uuid);
        $deleteConfirmBtn.data('code', couponCode);

        $productToRemoveSpan.empty().append(couponCode);
    });

    // Remove coupon code
    $('body').on('click', '.delete-coupon-confirmation-btn', function (e) {
        e.preventDefault();

        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var couponCode = $(this).data('code');
        var urlParams = {
            code: couponCode,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('body > .modal-backdrop').remove();

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                // $('.coupon-code-field').val('');
                // $('.coupon-code-field').removeAttr('disabled');
                // $('.promo-code-form .coupons-callout-msg').text('');
                // $('.promo-code-form .remove-coupon').data('code', '');
                // $('.promo-code-form .remove-coupon').data('uuid', '');
                // $('.promo-code-form .promo-code-btn').removeClass('d-none');
                // $('.promo-code-form .remove-coupon').addClass('d-none');
                // Reload the whole page if there are a different number of products.
                if ($('.card.product-info').length !== data.items.length) { // Number of items, not quantity
                    location.reload();
                } else {
                    $('.coupon-code-field').val('');
                    $('.coupon-uuid-' + uuid).remove();
                    var appliedCCLimitMax = $('.promo-code-form').data('appliedcclimitmax');
                    if (appliedCCLimitMax) {
                        var appliedCCLimitMaxInt = parseInt(appliedCCLimitMax, 10);
                        if (data.appliedCouponNumber >= appliedCCLimitMaxInt) {
                            $('.promo-code-form-fields').addClass('d-none');
                        } else {
                            $('.promo-code-form-fields').removeClass('d-none');
                        }
                    }
                    if (data.isImplicPromo) {
                        $('.implicitPromoDisplay').removeClass('d-none');
                    } else {
                        $('.implicitPromoDisplay').addClass('d-none');
                    }
                    updateCartTotals(data);
                    updateCartItems(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    validateBasket(data);

                    // Delay progress bar announcement to ensure it comes after other announcements
                    if (data.promoProgressBar) {
                        promoProgressBar.handle(data.promoProgressBar, 600);
                    }

                    updateOrderTotalsMinHeight();
                    $.spinner().stop();
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('body').on('click', '.cart-page .bonus-product-button', function () {
        $.spinner().start();
        $(this).addClass('launched-modal');
        $.ajax({
            url: $(this).data('url'),
            method: 'GET',
            dataType: 'json',
            success: function (data) {
                base.methods.editBonusProducts(data);
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });

    $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
        $('#chooseBonusProductModal').remove();
        $('.modal-backdrop').remove();
        $('body').removeClass('modal-open');

        if ($('.cart-page').length) {
            $('.launched-modal .btn-outline-primary').trigger('focus');
            $('.launched-modal').removeClass('launched-modal');
        } else {
            $('.product-detail .add-to-cart').focus();
        }
    });

    $('body').on('click keydown', '.cart-page .product-edit .edit, .cart-page .bundle-edit .edit, .cart-sheet .edit', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter') {
            return;
        }
        e.preventDefault();

        var editProductUrl = $(this).attr('href');
        var arialabel = $(e.currentTarget).data('modal-label') ||
                        $(e.currentTarget).find('[data-modal-label]').data('modal-label') || '';
        quickView.methods.getModalHtmlElement('editProductModal', arialabel);
        quickView.methods.fillModalElement(editProductUrl, 'editProductModal');
    });

    $('body').on('shown.bs.modal', '#editProductModal', function () {
        $('#editProductModal .modal-dialog').focus();
    });

    $('body').on('keydown', '#editProductModal', function (e) {
        var focusParams = {
            event: e,
            containerSelector: '#editProductModal'
        };
        focusHelper.setTabNextFocus(focusParams);
    });

    $('body').on('product:updateAddToCart', function (e, response) {
        // update global add to cart (single products, bundles)
        var $dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($dialog.length && $dialog.is(':visible')) {
            $('.update-cart-product-global').attr('disabled',
                $dialog.attr('data-available') !== 'true'
            );
        } else {
            $('.update-cart-product-global').attr('disabled',
                !$('.global-availability').attr('data-available') !== 'true'
            );
        }

        if (response.product.available) {
            $('.update-cart-product-global.btn.btn-primary').text($('.update-cart-product-global.btn.btn-primary').data('available-msg'));
        } else {
            $('.update-cart-product-global.btn.btn-primary').text($('.update-cart-product-global.btn.btn-primary').data('unavailable-msg'));
        }
        if (response.product.readyToOrder) {
            $('.update-cart-product-global').closest('.cart-and-ipay').find('.invalidAttr').addClass('d-none');
        }
        // Check if this is an eGift card product - if so, let eGiftCard.js handle it
        var isEGiftCard = response.product && response.product.isEGiftCard;
        if (isEGiftCard && response.product && response.product.available) {
            $('body').trigger('egiftcard:updateButton');
            return;
        }
    });

    $('body').on('product:updateAvailability', function (e, response) {
        // bundle individual products
        $('.product-availability', response.$productContainer)
            .data('ready-to-order', response.product.readyToOrder)
            .data('available', response.product.available)
            .find('.availability-msg')
            .empty()
            .html(response.message);


        var dialog = $(response.$productContainer)
            .closest('.quick-view-dialog');

        if ($('.product-availability', dialog).length) {
            // bundle all products
            var allAvailable = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('available'); });

            var allReady = $('.product-availability', dialog).toArray()
                .every(function (item) { return $(item).data('ready-to-order'); });

            $('.global-availability')
                .data('ready-to-order', allReady)
                .data('available', allAvailable);

            dialog.attr({
                'data-ready-to-order': allReady,
                'data-available': allAvailable
            });

            $('.global-availability .availability-msg', dialog).empty()
                .html(allReady ? response.message : '');
        } else {
            // single product
            $(dialog).attr({
                'data-ready-to-order': response.product.readyToOrder,
                'data-available': response.product.available
            });
            $('.global-availability', dialog)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .find('.availability-msg')
                .empty()
                .html(response.message);
        }
    });

    $('body').on('product:afterAttributeSelect', function (e, response) {
        if ($('.modal.show .product-quickview .bundle-items').length) {
            $('.modal.show').find(response.container).data('pid', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').text(response.data.product.manufacturerSKU);
            $('.modal.show').find(response.container).find('.product-id').data('product-upc', response.data.product.id);
            $('.modal.show').find(response.container).find('.product-id').data('style-number', response.data.product.manufacturerSKU);
        } else {
            $('.modal.show .product-quickview').data('pid', response.data.product.id);
            $('.modal.show .product-quickview').find(response.container).find('.product-id').text(response.data.product.manufacturerSKU);
            $('.modal.show .product-quickview').find(response.container).find('.product-id').data('product-upc', response.data.product.id);
            $('.modal.show .product-quickview').find(response.container).find('.product-id').data('style-number', response.data.product.manufacturerSKU);
        }
    });

    $('body').on('change', '.quantity-select', function () {
        var selectedQuantity = $(this).val();
        $('.modal.show .update-cart-url').data('selected-quantity', selectedQuantity);
    });

    $('body').on('click', '.update-cart-product-global', function (e) {
        e.preventDefault();

        if ($(this).attr('aria-disabled') === 'true') {
            return;
        }

        var updateProductUrl = $(this).closest('.cart-and-ipay').find('.update-cart-url').val();
        var selectedQuantity = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('selected-quantity');
        var uuid = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('uuid');
        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.quick-view-dialog').find('.product-detail');
        }
        $('.invalidAttr').addClass('d-none');
        var readyToOrder = true;
        $productContainer.find('.product-attribute').each(function () {
            if ($(this).hasClass('e-gift-card-attribute')) {
                var $customAmount = $productContainer.find('[id*="egiftcard-custom-amount"]');
                if ($customAmount.length && $customAmount.val() && $customAmount.val().trim() !== '') {
                    return;
                }
            }
            if ($(this).find('.selected').length === 0) {
                $(this).find('.invalidAttr').removeClass('d-none');
                readyToOrder = false;
            }
        });
        if (!readyToOrder) {
            $(this).closest('.cart-and-ipay').find('.invalidAttr').removeClass('d-none');
            return;
        }

        var selectedOptionValueId = [];
        $productContainer.find('.product-option').each(function () {
            selectedOptionValueId.push($(this).data('value-id'));
        });

        var $customForm = null;
          // handle the addition of custom "attributes" on the PDP
        var customFormName = $(this).data('custom-form-name');
        var customData = {};
        if (customFormName && $productContainer.find('form[name="' + customFormName + '"]').length) {
            // get form object
            $customForm = $productContainer.find('form[name="' + $(this).data('custom-form-name') + '"]');
            var $form = $productContainer.find('form.egift-card');
            var input = $form.find('input[id*="egiftcard-form-recipient-emailconfirm"]');
            var isValid = validateForm($customForm[0]);
            var isvalidateElement = validateFormElement(input);
            if (!isValid || !isvalidateElement) {
                return;
            }
            customData = $customForm.serializeArray().reduce(function (obj, item) {
                obj[item.name] = item.value ? item.value.trim() : ''; // eslint-disable-line no-param-reassign
                return obj;
            }, {});
        }

        var isMiniCart = $('.minicart-flyout.show').length > 0;

        var form = {
            uuid: uuid,
            pid: base.getPidValue($(this)),
            quantity: selectedQuantity,
            selectedOptionValueId: selectedOptionValueId.toString(),
            customData: JSON.stringify(customData),
            isMiniCart: isMiniCart
        };

        $(this).parents('.modal.show .modal-dialog').spinner().start();
        if (updateProductUrl) {
            $.ajax({
                url: updateProductUrl,
                type: 'post',
                context: this,
                data: form,
                dataType: 'json',
                success: function (data) {
                    if (data.cartModel.isImplicPromo) {
                        $('.implicitPromoDisplay').removeClass('d-none');
                    } else {
                        $('.implicitPromoDisplay').addClass('d-none');
                    }
                    $('.coupons-and-promos').empty().append(data.cartModel.totals.discountsHtml);
                    updateCartTotals(data.cartModel);
                    updateCartItems(data.cartModel);
                    updateApproachingDiscounts(data.cartModel.approachingDiscounts);
                    updateAvailability(data.cartModel, uuid);
                    updateProductDetails(data, uuid);

                    if (data.uuidToBeDeleted) {
                        $('.uuid-' + data.uuidToBeDeleted).remove();
                    }

                    validateBasket(data.cartModel);

                    // Announce "Changes Saved" to screen readers
                    $('.saved-changes').text('Changes Saved');

                    // Announce quantity change separately to screen readers
                    var quantityMsgTemplate = $(this).closest('.cart-and-ipay').find('.update-cart-url').data('quantity-updated-msg');
                    var quantityAnnouncementMsg = quantityMsgTemplate ? quantityMsgTemplate.replace('{0}', selectedQuantity) : 'Quantity updated successfully to ' + selectedQuantity;
                    $('.quantity-change-announcement').text(quantityAnnouncementMsg);

                    if (data.addedItemNotificationMIniCartHtml && !$('.minicart-flyout.show.oots-items').length) {
                        $('.cart-sheet .product-summary').html(data.addedItemNotificationMIniCartHtml);
                    }
                    $('body').trigger('cart:update');

                    quickView.methods.slideQuickviewOut();
                    let productCard = $('.card.product-info.uuid-' + uuid);
                    setTimeout(() => {
                        $(productCard).find('a').focus();
                    }, 150);

                    if (data.cartModel.promoProgressBar) {
                        $('.quick-modal').on('hidden.bs.modal', function () {
                            promoProgressBar.handle(data.cartModel.promoProgressBar);
                        });
                    }
                },
                error: function (err) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    $('body').on('updateCartPage', function (e, eventData) {
        if ($('.cart-page').length > 0) {
            if (eventData.cart.isImplicPromo) {
                $('.implicitPromoDisplay').removeClass('d-none');
            } else {
                $('.implicitPromoDisplay').addClass('d-none');
            }
            $('.coupons-and-promos').empty().append(eventData.cart.totals.discountsHtml);
            updateCartTotals(eventData.cart);
            updateCartItems(eventData.cart);
            updateApproachingDiscounts(eventData.cart.approachingDiscounts);
            updateAvailability(eventData.cart, eventData.pliUUID);
            validateBasket(eventData.cart);

            // Delay progress bar announcement to ensure it comes after other announcements
            if (eventData.cart.promoProgressBar) {
                promoProgressBar.handle(eventData.cart.promoProgressBar, 600);
            }

            if (eventData.addedItemNotificationMIniCartHtml && !$('.minicart-flyout.show.oots-items').length) {
                $('.cart-sheet .product-summary').html(eventData.addedItemNotificationMIniCartHtml);
            }
            $('body').trigger('cart:update');

            quickView.methods.slideQuickviewOut();
        }
    });

    $(document).on('click keydown', '.decrease-qty-button', function (e) {
        if ((e.type === 'keydown' && e.key !== 'Enter') || (e.type === 'keydown' && e.key === 'Enter' && !$(this).closest('.minicart-flyout').length)) {
            return;
        }
        var $qtySelector = $(this).closest('.quantity-selector').find('input.quantity-select');
        var value = parseInt($qtySelector.val(), 10);
        var minQty = parseInt($(this).closest('.quantity-selector').find('input.min-order-qty').val(), 10);
        value = isNaN(value) ? 0 : value -= 1;
        if (value >= minQty) {
            $qtySelector.val(value);
            $($qtySelector).trigger('change');
        }
    });
    $(document).on('click keydown', '.increase-qty-button', function (e) {
        if ((e.type === 'keydown' && e.key !== 'Enter') || (e.type === 'keydown' && e.key === 'Enter' && !$(this).closest('.minicart-flyout').length)) {
            return;
        }
        var $qtySelector = $(this).closest('.quantity-selector').find('input.quantity-select');
        var value = parseInt($qtySelector.val(), 10);
        var maxQty = parseInt($(this).closest('.quantity-selector').find('input.max-order-qty').val(), 10);
        value = isNaN(value) ? 0 : value += 1;
        if (value <= maxQty) {
            $qtySelector.val(value);
            $($qtySelector).trigger('change');
        }
    });

    $('body').on('click', '.apple-pay.js-cart-oot-items', function (e) {
        e.preventDefault();
        $('body').trigger('showOotModal');
    });

    $('body').on('click keydown', '.checkout-btn', function (e) {
        if (e.type === 'keydown' && e.key !== 'Enter') return;
        e.preventDefault();
        var $this = $(this);
        var url = $this.data('invetory');
        var isApplePaySupport = window.ApplePaySession && window.ApplePaySession.canMakePayments();
        var isMiniCartActive = $('.minicart .popover').hasClass('show');
        if (!isMiniCartActive) $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            context: this,
            dataType: 'json',
            success: function (data) {
                if (data.outOfStockProducts.length > 0) {
                    $.spinner().stop();
                    $('body').trigger('showOotModal');
                } else if ($this.hasClass('user-registered') && isApplePaySupport === undefined) {
                    window.location.href = $this.data('register-url');
                } else if ($this.hasClass('user-registered') && $this.data('apple-pay') === null && isApplePaySupport) {
                    window.location.href = $this.data('register-url');
                } else {
                    $.spinner().stop();
                    window.location.href = $this.data('guest-url');
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
    $('body').on('click', '.hazmat-remove-product', function (e) {
        e.preventDefault();

        var actionUrl = $(this).data('action');
        var productID = $(this).data('pid');
        var productName = $(this).data('name');
        var uuid = $(this).data('uuid');
        confirmDeleteForHazmat(actionUrl, productID, productName, uuid);
    });

    $('body').on('afterRemoveFromCart', function (e, data) {
        e.preventDefault();
        confirmDeleteForHazmat(data.actionUrl, data.productID, data.productName, data.uuid);
    });

    $('body').on('click', '.hazmat-cart-delete-confirmation-btn', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $('#hazardousModal').spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                if (data.basket.items.length === 0) {
                    $('#hazardousModal').modal('hide');
                    window.location.href = $('#cartPageNavigation').val();
                } else {
                    if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                        for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                            $('.product-line-item-' + data.toBeDeletedUUIDs[i]).remove();
                            $('.hazmat-product-line-item-' + data.toBeDeletedUUIDs[i]).remove();
                        }
                    }

                    $('.product-line-item-' + uuid).remove();
                    $('.hazmat-product-line-item-' + uuid).remove();

                    var hazmatProductUUIDs = '';
                    for (var j = 0; j < data.basket.items.length; j++) {
                        if (data.basket.items[j].isHazardousMaterial) {
                            hazmatProductUUIDs += '|' + data.basket.items[j].UUID;
                        }
                    }

                    if (hazmatProductUUIDs) {
                        var hazmatProductLineItems = $('.hazmat-product-line-item');
                        for (var k = 0; k < hazmatProductLineItems.length; k++) {
                            var dataCurrentUUID = hazmatProductLineItems[k].getAttribute('data-current-uuid');
                            if (dataCurrentUUID && hazmatProductUUIDs.indexOf(dataCurrentUUID) === -1) {
                                $('.hazmat-product-line-item-' + dataCurrentUUID).remove();
                                $('.product-line-item-' + dataCurrentUUID).remove();
                            }
                        }
                    }

                    $('.coupons-and-promos').empty().append(data.basket.totals.discountsHtml);
                    // Pass null to skip announcement in updateCartTotals (we'll announce explicitly below)
                    updateCartTotals(data.basket, null);

                    // Announce item count after hazmat removal with delay to allow DOM to stabilize
                    if (data.basket.resources && data.basket.resources.numberOfItems) {
                        focusHelper.announceCartItemsCount(data.basket.resources.numberOfItems, 300);
                    }

                    $('#isHazardousProducts').val(data.isHazardousProducts);

                    if (!data.isHazardousProducts && !$('.hazmat-products-shipping-disclaimer').hasClass('d-none')) {
                        $('.hazmat-products-shipping-disclaimer').addClass('d-none');
                        $('select[name$="shippingAddress_addressFields_country"]').trigger('change');
                    }
                }

                $('body').trigger('cart:update');
                if ($('.hazmat-cart-body').find('.hazmat-product-line-item').length === 0) {
                    $('#hazardousModal').modal('hide');
                    if ($('#checkout-main').data('checkout-stage') === 'shipping') {
                        $('.next-step-button').find('button[data-form="#dwfrm_shipping"]').trigger('click');
                    } else if ($('#checkout-main').data('checkout-stage') === 'payment') {
                        $('.next-step-button').find('button[data-form="#dwfrm_billing"]').trigger('click');
                    }
                }

                $('#hazardousModal').spinner().stop();

                if (data.gtmDataLayer) {
                    window.dataLayer = window.dataLayer || [];
                    for (var ind = 0; ind < data.gtmDataLayer.length; ind++) {
                        window.dataLayer.push(data.gtmDataLayer[ind]);
                    }
                }

                if ($('.hazardous-modal.show')) {
                    $('body').addClass('modal-open');
                }
            },
            error: function (err) {
                if (err.responseJSON.redirectUrl) {
                    window.location.href = err.responseJSON.redirectUrl;
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });

    $('.modify-ship-address, .change-shipping-country').on('click', function (e) {
        e.preventDefault();
        var actionUrl = $(this).data('action');
        if (actionUrl) {
            var applePayEmail = sessionStorage.getItem('applePayEmail');
            if (applePayEmail) {
                actionUrl = appendToUrl(actionUrl, { email: applePayEmail, modifyShippingAddress: true });
                sessionStorage.removeItem('applePayEmail');
            }
            location.assign(actionUrl);
        }
    });

    initRecommendationSlider();
    centerSlickArrows();

    $('body').on('initRecommendationSlider', function () {
        initRecommendationSlider();
        centerSlickArrows();
    });
    $('body').on('click', '.sticky-cart-footer .promo-wrapper .promoCodeTab', function () {
        const $orderTotalsWrapper = $('.order-totals-wrapper');
        const $collapsePromo = $('.collapsePromo');

        if (!$collapsePromo.hasClass('show')) {
            // If .collapsePromo has class "show"
            $orderTotalsWrapper.css('min-height', (index, value) => {
                return (parseInt(value, 10) || 0) + 60 + 'px';
            });
            programmaticScrollTo(document.body.scrollHeight);
        } else {
            // If .collapsePromo does not have class "show"
            $orderTotalsWrapper.css('min-height', (index, value) => {
                return ((parseInt(value, 10) || 0) - 60) + 'px';
            });
        }
    });

    const throttledHandleScroll = _.throttle(handleScroll, 100);
    window.addEventListener('scroll', throttledHandleScroll);
    const promoInput = document.getElementsByClassName('coupon-code-field')[0];
    const applyButton = document.getElementsByClassName('promo-code-btn')[0];

    if (applyButton && promoInput) {
        promoInput.addEventListener('keydown', function (e) {
            if (e.key === 'ArrowRight' && this.selectionEnd === this.value.length) {
                e.preventDefault();
                applyButton.focus();
            }
        });
    }

    const throttledCenterSlickArrows = debounce(centerSlickArrows, 100);
    $(window).on('resize orientationchange', function () {
        throttledCenterSlickArrows();
    });

    $(window).on('load', handleGlobaleCountrySwitcher());
    $('body').on('click', '.globale-country-modal-redirect-link', function (e) {
        if ($('.page').data('action') === 'Cart-Show') {
            e.preventDefault();
            var countryCode = $(this).data('country-code');
            var currencyCode = $(this).data('currency-code');
            $('#globaleCountryModal').modal('hide');
            handleGlobaleCountrySwitcher(countryCode, currencyCode);
        }
    });

    base.selectAttribute();
    base.colorAttribute();
    base.setColorAttribute();
    base.swatchesAttribute();
    base.removeBonusProduct();
    base.selectBonusProduct();
    base.enableBonusProductSelection();
    base.showMoreBonusProducts();
    base.addBonusProductsToCart();
    base.focusChooseBonusProductModal();
    base.trapChooseBonusProductModalFocus();
    base.onClosingChooseBonusProductModal();
    base.initGiftMessageCharacterCounter();
    base.handlePDPVideo(); // PMG-1018 OLD Cloudinary
    handleApplePayErrors();
    promoProgressBar.initTooltip();
};
